import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return undefined;
    }

    const targetId = decodeURIComponent(hash.replace("#", ""));
    let attempts = 0;
    let timerId;

    const scrollToTarget = () => {
      const target = document.getElementById(targetId);

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      attempts += 1;
      if (attempts < 20) {
        timerId = window.setTimeout(scrollToTarget, 75);
      }
    };

    timerId = window.setTimeout(scrollToTarget, 0);
    return () => window.clearTimeout(timerId);
  }, [pathname, search, hash]);

  return null;
}

export default ScrollToTop;
